export const getSubdomainAffixed = function (url) {
  if (!url) {
    return
  }

  let qtdBars = url.split('').filter(c => c === '/').length
  if (qtdBars > 2) {

    if (qtdBars === 3) {
      return ''
    }

    let q = 0
    let slashIndex = url.split('').findIndex((c, i) => {
      if (c === '/') {
        if (q === 2) {
          return i
        }
        q++
      }
    })

    let strAffix = url.slice(slashIndex + 1)

    let re = new RegExp('[\/?=]', 'gi')
    re.lastIndex = 0
    let reExec = re.exec(strAffix)
    if (reExec) {
      let finalIndex = reExec.index
      
      let str = strAffix.slice(0, finalIndex)
      if (str !== 'auth') {
        return str
      }
      return ''
    }
    if (strAffix !== 'auth') {
      return strAffix
    }
    return ''
  }
}

export const resolveAsset = function (filename: string): string {

 
  if (!filename) {
    return 
  }
  if (filename.includes('http')) {
    return filename
  }

  let directory = ''
  let imagesExtensions = ['png', 'jpg', 'jpeg', 'gif']
  if (imagesExtensions.some(ext => filename.includes(ext))) {
    directory = 'img'
  }

  if (filename.includes('umd.js')) {
    directory = 'fn'
  }

  let prefix = getSubdomainAffixed(window.location.href)

  let completePrefix = window.location.protocol + '//' + window.location.host

  if (prefix) {
    completePrefix = `${completePrefix}/${prefix}`
  }
  
  return `${completePrefix}/assets/${directory}/${filename}`
}


